import CacheableJson from '../../../../core/collections/CacheableJson';
import TippingTeam from '../../models/TippingTeam';

/**
 * @desc Rankings
 * This Overall Ladderer Collection
 */
export class RankingsCollection extends CacheableJson {
	get model() {
		return TippingTeam;
	}

	setCompsLadderUrl() {
		this.url = 'comps/rankings';
		return this;
	}

	showCompsOverallRankings(data = {}) {
		this.setCompsLadderUrl();
		return this.fetchData(data);
	}

	setOverallLadderUrl() {
		this.url = 'tipping/rankings';
		return this;
	}

	showOverallLadder(data = {}) {
		this.setOverallLadderUrl();
		return this.fetchData(data);
	}

	showStreakRankings(data = {}) {
		this.url = 'gauntlet/rankings';
		return this.fetchData(data);
	}

	fetchData(data = {}) {
		return this.fetch({ data }).then(response => {
			let count_teams = response.result.length;
			this.trigger('response:overall:teams:count', count_teams);
		});
	}
}

export default RankingsCollection;